/* Cart drawer "Complete the look" — fills [data-wa-upsell] in snippets/cart-drawer.liquid with cards from sections/wa-cart-upsell.liquid.
   Source, for the most recent line in the cart: Search & Discovery "complementary products" first (intent=complementary),
   topped up to 4 with Shopify's automatic related products (intent=related). The section already drops items in the cart
   and sold-out products; this file de-duplicates across the two lists.
   Runs again after every drawer render (add, quantity change, remove), because the theme replaces the drawer HTML each time. */
(function () {
  const MAX = 4;
  const cache = new Map();
  let pending = null;

  function slot() { return document.querySelector('cart-drawer [data-wa-upsell]'); }

  // Resolves { head, cards } where head = the section's stylesheet link + title, cards = the card elements, or null.
  function fetchSection(productId, intent) {
    const base = (window.routes && window.routes.product_recommendations_url) || '/recommendations/products';
    const url = base + '?section_id=wa-cart-upsell&product_id=' + encodeURIComponent(productId) + '&intent=' + intent + '&limit=8';
    return fetch(url)
      .then((r) => (r.ok ? r.text() : ''))
      .then((text) => {
        if (!text) return null;
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const grid = doc.querySelector('.wa-up__grid');
        if (!grid || !grid.children.length) return null;
        const head = [...doc.querySelector('.shopify-section').children].filter((el) => el !== grid).map((el) => el.outerHTML).join('');
        return { head, cards: [...grid.children] };
      })
      .catch(() => null);
  }

  function compose(complementary, related) {
    const seen = new Set();
    const cards = [];
    [complementary, related].forEach((res) => {
      if (!res) return;
      res.cards.forEach((card) => {
        const link = card.querySelector('.wa-up__info');
        const id = link ? link.getAttribute('href') : card.innerHTML;
        if (seen.has(id) || cards.length >= MAX) return;
        seen.add(id);
        cards.push(card.outerHTML);
      });
    });
    if (!cards.length) return '';
    const head = (complementary || related).head;
    return head + '<div class="wa-up__grid">' + cards.join('') + '</div>';
  }

  function show(key, html) {
    const el = slot();
    if (!el || el.dataset.key !== key) return; // drawer re-rendered meanwhile; the next refresh will handle it
    el.innerHTML = html;
    el.hidden = !html;
  }

  function refresh() {
    const el = slot();
    if (!el) return;
    const productId = el.dataset.productId;
    const key = productId + '|' + (el.dataset.cartKey || '');
    el.dataset.key = key;
    if (!productId) return;
    if (cache.has(key)) { show(key, cache.get(key)); return; }
    if (pending === key) return;
    pending = key;
    fetchSection(productId, 'complementary')
      .then((comp) => (comp && comp.cards.length >= MAX ? [comp, null] : fetchSection(productId, 'related').then((rel) => [comp, rel])))
      .then(([comp, rel]) => { const html = compose(comp, rel); cache.set(key, html); show(key, html); })
      .finally(() => { if (pending === key) pending = null; });
  }

  const later = () => setTimeout(refresh, 60);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, later);
  document.addEventListener('cart:change', later);
  const drawer = document.querySelector('cart-drawer');
  if (drawer) {
    new MutationObserver(() => { if (drawer.classList.contains('active')) refresh(); })
      .observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }
  refresh();
})();